import { client } from "@/config/client"

export function updateLives() {
  return client.put(`/v1/users/decrement-lives`)
}
